const CodeType = {
  order: { color: "green-vito" },
  supplier: { color: "primary" },
  technician: { color: "info" },
  urgency: { color: "red-vito" },
  open_lock: { color: "green-vito" },
};
export default CodeType;
